import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

/**
 * Higher-order component to inject React Router v6 hooks into class components
 * Provides params, navigate, and location as props
 */
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();

    return (
      <Component
        {...props}
        routeParams={params}
        navigate={navigate}
        location={location}
      />
    );
  }

  return ComponentWithRouterProp;
}
